/** Cores de marca de serviços externos */
export const BRAND_COLORS = {
  whatsapp: '#25D366',
  telegram: '#0088cc',
  twitter: '#1DA1F2',
  email: undefined, // usa T.accent
} as const;

/** Cores de brand do programa de referral */
export const REFERRAL_ACCENT = {
  rosa: '#EC4899',
  azul: '#62D0FF',
} as const;
